// @flow

import saveValuation from '../../../Services/saveValuation';

export default () => async (dispatch: Function) => {
  
  await dispatch(saveValuation());
  
}